import React, { useEffect } from "react";
import WOW from "wowjs";
import "./Services.css";

const Services = () => {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <section id="main">
      <div class="inner">
        <section id="one" class="wrapper style1">
          <div
            class="container"
            style={{ paddingTop: "150px", marginBottom: "0" }}
          >
            <div
              class="page-header text-center wow fadeInDown"
              data-wow-delay="0.4s"
            >
              <h2 style={{ color: "aliceblue", fontSize: "50px" }}>
                Our Services
              </h2>
              <div class="devider" style={{ paddingBottom: "0px" }}></div>
            </div>
          </div>
          <div class="content">
            <p style={{ color: "gray" }}></p>
          </div>
        </section>

        <section id="two" class="wow fadeInUp wrapper style2">
          <header>
            <h2>What do we do</h2>
            <p>WE GET OUR HANDS GREASY, THATS WHAT!</p>
          </header>
        </section>

        <section id="three" class="wrapper">
          <div class="wow fadeInLeft spotlight">
            <div class="imagee flush">
              <img src="./img/TLB.jpg" alt="" />
            </div>
            <div class="inner">
              <h3 style={{ color: "aliceblue" }}>
                Heavy Machinery
              </h3>
              <p style={{ color: "#faebd7" }}>
                
              </p>
            </div>
          </div>

          <div class="wow fadeInRight spotlight alt">
            <div class="imagee flush">
              <img src="./img/tractor.jpeg" alt="" />
            </div>
            <div class="inner">
              <h3>Tractors</h3>
              <p style={{ color: "#faebd7" }}>
                
              </p>
            </div>
          </div>

          <div class="wow fadeInLeft spotlight">
            <div class="imagee flush">
              <img src="./img/truck.jpg" alt="" />
            </div>
            <div class="inner">
              <h3 style={{ color: "aliceblue" }}>Trucks</h3>
              <p style={{ color: "#faebd7" }}>
                
              </p>
            </div>
          </div>

          <div class="wow fadeInRight spotlight alt">
            <div class="imagee flush">
              <img src="./img/generator.jpeg" alt="" />
            </div>
            <div class="inner">
              <h3>Generators</h3>
              <p style={{ color: "#faebd7" }}>
                
              </p>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};
export default Services;
